import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';

class Footer extends Component {

  state = {
    noFooter: this.props._userconfig.SideBarConfig.module,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ noFooter: nextProps._userconfig.SideBarConfig.module });
  }

  render() {
    const year = new Date().getFullYear();
    let { noFooter } = this.state;
    return (
      <footer style={{ display: noFooter === "epointAnalytics" ? "none" : '' }} className="footer-container">
        <span>&copy; Copyright {year}, xpd global. {this.props.t("reserved_rights")}</span>
      </footer>
    );
  }
}

export default withNamespaces()(Footer);
